export function sanitizeStoreInternalURL(url: string): string {
  const urlWithoutSpaces = url.trim().replace(/\s/g, '-');
  return urlWithoutSpaces.replace(/[^a-zA-Z0-9-]/g, '').toLowerCase();
}

export function formatShopUrl(shopUrl: string): string {
  const cleanUrl = shopUrl.replace(/^https?:\/\//, '').replace(/\/+$/, '');

  if (!cleanUrl.includes('.') && isShopifyHandle(cleanUrl)) {
    return `${cleanUrl}.myshopify.com`;
  }

  return cleanUrl;
}

function isShopifyHandle(value: string): boolean {
  if (value.includes(':')) return false;
  if (/^\d{1,3}(\.\d{1,3}){0,3}$/.test(value)) return false;
  if (/^localhost$/i.test(value)) return false;
  return true;
}

export function urlVariants(raw: string): string[] {
  const bare = formatShopUrl(raw);
  const cleaned = raw.replace(/^https?:\/\//, '').replace(/\/+$/, '');

  const variants = new Set([
    bare,
    `https://${bare}`,
    `http://${bare}`,
    `${bare}/`,
    `https://${bare}/`,
    `http://${bare}/`,
  ]);

  if (cleaned !== bare) {
    variants.add(cleaned);
    variants.add(`https://${cleaned}`);
    variants.add(`http://${cleaned}`);
    variants.add(`${cleaned}/`);
    variants.add(`https://${cleaned}/`);
    variants.add(`http://${cleaned}/`);
  }

  return [...variants];
}
